import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import ProfileTitle from '../../../../../layout/mobile/profile/ProfileTitle';
import Tracking from '../../tracking/Tracking';
import TruckIcon from '../../../../../common/icons/truckIcon';
import { PURCHASE_ROUTE } from '../../../../../../constants/Routes';

const TrackingMobileView = ({ ...props }) => {
  const { mobile } = props;
  const location = useLocation();
  const history = useHistory();
  const { state } = location;
  const { products } = useSelector((state) => state.productReducer);
  const [dispatch, setDispatch] = useState({});

  useEffect(() => {
    if (!state) history.push(PURCHASE_ROUTE);
  }, []);

  useEffect(() => {
    if (state) {
      setDispatch(
        products.filter(
          (product) =>
            product.orderId === state.orderId && product.sku === state.sku,
        )[0].dispatch,
      );
    }
  }, [products]);

  return (
    <Box marginTop="24px">
      {state?.orderId && (
        <>
          <ProfileTitle
            title="Seguir mi compra"
            subtitle={`Estado de compra de ${state.name}`}
            mobile={mobile}
            icon={<TruckIcon size="30px" color="#6A148E" />}
          />
          <Tracking
            dispatch={dispatch}
            orderId={state.orderId}
            errorTracking={state.errorTracking}
            mobile={mobile}
          />
        </>
      )}
    </Box>
  );
};

TrackingMobileView.propTypes = {
  mobile: PropTypes.bool,
};

export default TrackingMobileView;
